<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="page_xxvi"></a>The following is an account of operations involving 656 Squadron, Army Air Corps, in Afghanistan over several months in 2006 and 2007. At the time of going to print, some inquests have not yet been held into the deaths of British Army and Royal Marine personnel reported in these pages. The author has, to the best of his knowledge, reported events faithfully and accurately and any insult or injury to any of the parties described or quoted herein or to their families is unintentional. The publishers will be happy to correct any inaccuracies in later editions.</p>
<p class="noindent1">Identities have been obscured in a few cases to protect the individuals and their families.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?1b3d63ff